import { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router";
import API from "../../common/API";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
    isCedulaIdentifier,
    isRncIdentifier,
    normalizeRecordIdentifier,
} from "../../common/recordIdentifier";

import RecordRelatives from "./RecordRelatives";
import RecordBiometrical from "./RecordBiometrical";
import RecordJudicialRecords from "./RecordJudicialRecords";

import RecordTelefonos from "./RecordTelefonos";
import RecordProviderContracts from "./RecordProviderContracts";
import RecordDGIIInfo from "./RecordDGIIInfo";
import RecordEstructura from "./RecordEstructura";
import RecordSalarios from "./RecordSalarios";
import RecordSentencias from "./RecordSentencias";
import RecordAudiencias from "./RecordAudiencias";
import RecordVictimarios from "./RecordVictimarios";
import { parsedUser } from "../../common/GetCurrentUser";
import AdminContainerModal from "../Admin/AdminContainerModal";
import FlagsModal from "./FlagsModal";

interface GeneralInfo {
    imagen?: string;
    nombres?: string;
    apellido1?: string;
    apellido2?: string;
    cedula?: string;
    fechaNacimiento?: string;
    alias?: string;
    sexo?: string;
    edad?: number;
    lugarNacimiento?: string;
    fichado?: boolean;
    extraditado?: boolean;
    fichas?: number;
    desaparecido?: boolean;
    deportado?: boolean;
}

const RecordContainer = (props: any) => {
    const [generalInfo, setGeneralInfo] = useState<any>(null);
    const [hasLaborales, setHasLaborales] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const { id } = useParams<{ id: string }>();
    const user = parsedUser();
    const [showAdmin, setShowAdmin] = useState(false);
    const [showFlags, setShowFlags] = useState(false);
    const { t } = useTranslation();
    const normalizedId = normalizeRecordIdentifier(id);
    const isCedula = isCedulaIdentifier(id);
    const isRnc = isRncIdentifier(id);
    const canLookupRecord = isCedula || isRnc;

    const bindGeneral = async () => {
        if (!canLookupRecord) {
            setGeneralInfo(null);
            setIsLoading(false);
            return;
        }

        try {
            setIsLoading(true);

            const requestURLs = isRnc
                ? [`dgii/contribuyentes?rnc=${normalizedId}`]
                : [
                    `busqueda/nacionales?cedula=${normalizedId}&external=false`,
                    `busqueda/nacionales?cedula=${normalizedId}`,
                ];

            for (const requestURL of requestURLs) {
                try {
                    const request = await API.getAction(requestURL);
                    if (request.status === 200) {
                        const data = request.data.response;
                        if (data && data.length > 0) {
                            setGeneralInfo(data[0]);
                            return;
                        }
                    }
                } catch (requestError) {
                    console.error(`Error fetching general data from ${requestURL}:`, requestError);
                }
            }

            setGeneralInfo(null);
        } catch (error) {
            console.error("Error fetching general data:", error);
        }
        finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        if (id) {
            bindGeneral();
        } else {
            setGeneralInfo(null);
            setIsLoading(false);
        }
    }, [id, normalizedId])

    if (!generalInfo && isLoading) {
        return <div className="text-center my-4">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>;
    }
    return (
        <>
            {showAdmin && (
                <AdminContainerModal toggle={() => setShowAdmin(!showAdmin)} />
            )}
            {user && user.RoleId === "admin" && (
                <button
                    className="btn btn-primary position-fixed"
                    style={{
                        bottom: "24px",
                        right: "24px",
                        zIndex: 1050,
                        borderRadius: "999px",
                        width: "52px",
                        height: "52px",
                    }}
                    onClick={() => {
                        setShowFlags(true)
                    }}
                    title={`${t("Banderas") ?? ""}`}
                >
                    <i className="fa fa-flag" />
                </button>
            )}
            <FlagsModal
                show={showFlags}
                identificador={id}
                onClose={() => setShowFlags(false)}
            />
            <Container>
                <Row>
                    <Col className="mx-auto"  >
                        {generalInfo && isCedula &&
                            <Card className="my-4">
                                <Card.Body className="p-4 ">
                                    <Row>
                                        <Col xs="auto">
                                            {generalInfo.imagen && (
                                                <img
                                                    alt=""
                                                    className="card-img-top"

                                                    style={{ height: "200px", width: "200px", objectFit: "cover" }}
                                                    // style={{ maxHeight: "175px" }}
                                                    id="image"
                                                    src={"data:image/png;base64," + generalInfo.imagen}
                                                />
                                            )}
                                        </Col>
                                        <Col>
                                            <b className="me-2">{t("Name")}:</b>
                                            {`${generalInfo.nombres ?? ""} ${generalInfo.apellido1 ?? ""
                                                } ${generalInfo.apellido2 ?? ""}`}
                                            <br />
                                            <b className="me-2">Cédula</b>
                                            {generalInfo.cedula}
                                            <br />
                                            <b className="me-2">{t("Fecha de Nacimiento")}</b>
                                            {generalInfo.fechaNacimiento &&
                                                moment(
                                                    generalInfo.fechaNacimiento.substring(0, 10)
                                                ).format("DD/MM/YYYY")}
                                            <br />
                                            {generalInfo.alias && <>
                                                <b className="me-2">{t("Alias")}</b>
                                                {generalInfo.alias}
                                                <br />
                                            </>}
                                            <b className="me-2">{t("Género")}</b>
                                            {generalInfo.sexo === "M" ? "Masculino" : "Femenino"}
                                            <br />
                                            <b className="me-2">{t("Edad")}</b>
                                            {generalInfo.edad ? Math.round(generalInfo.edad) : 0}
                                            <br />

                                            <b className="me-2">{t("Lugar de nacimiento")}</b>
                                            {generalInfo.lugarNacimiento}
                                        </Col>
                                        <Col>
                                            <b>CLASIFICACIÓN</b><br />
                                            {generalInfo.banderas && (generalInfo.banderas as any).pip && (
                                                <>
                                                    <span className="badge bg-danger text-white text-wrap" title="Persona Imputada Penalmente">
                                                        PIP
                                                    </span>
                                                    <br />
                                                </>
                                            )}
                                            {generalInfo.banderas && (generalInfo.banderas as any).padep && (
                                                <>
                                                    <span className="badge bg-danger text-white text-wrap" title="Persona Asociada a un Delito Precedente">
                                                        PADEP
                                                    </span>
                                                    <br />
                                                </>
                                            )}
                                            {generalInfo.banderas && (generalInfo.banderas as any).rasadep && (
                                                <>
                                                    <span className="badge bg-danger text-white text-wrap" title="Razón Social Asociada a un Delito Precedente">
                                                        RASADEP
                                                    </span>
                                                    <br />
                                                </>
                                            )}
                                            {generalInfo.banderas && (generalInfo.banderas as any).pep && (
                                                <>
                                                    <span className="badge bg-warning text-dark text-wrap" title="Persona Expuesta Públicamente">
                                                        PEP
                                                    </span>
                                                    <br />
                                                </>
                                            )}
                                            {generalInfo.banderas && (generalInfo.banderas as any).fallecido && (
                                                <>
                                                    <span className="badge text-white text-wrap" style={{ backgroundColor: "#000" }} title="Fallecido">
                                                        FALLECIDO
                                                    </span>
                                                    <br />
                                                </>
                                            )}
                                            {generalInfo.victimaIndividual && (
                                                <>
                                                    <span className="badge bg-info text-white text-wrap" title="Aparece como víctima en casos penales">
                                                        VÍCTIMA INDIVIDUAL
                                                    </span>
                                                    <br />
                                                </>
                                            )}
                                            {generalInfo.victimaEstructura && (
                                                <>
                                                    <span className="badge bg-secondary text-white text-wrap" title="Aparece como víctima en estructuras delictivas">
                                                        VÍCTIMA DE ESTRUCTURA
                                                    </span>
                                                    <br />
                                                </>
                                            )}
                                            <hr className="my-2" />
                                            <b>RECOMENDACIONES</b><br />
                                            {!generalInfo.fichado && (
                                                <>
                                                    <div
                                                        className="badge bg-success text-wrap"
                                                        title={"No antencedentes judiciales"}
                                                    >
                                                        <i className="fa fa-check"></i>
                                                        <span className="ms-2">No antencedentes judiciales</span>
                                                    </div>
                                                    <br />
                                                </>
                                            )}
                                            {generalInfo.extraditado && (
                                                <> <span
                                                    className="badge "
                                                    style={{ backgroundColor: "blue" }}
                                                    title={
                                                        "Solicitar certificado de no extradicción"
                                                    }
                                                >
                                                    <i className="fa fa-exclamation-triangle me-2"></i>
                                                    Solicitar certificado de no extradicción
                                                </span>
                                                    <br />
                                                </>
                                            )}
                                            {(generalInfo.fichas ?? 0) > 1 && (<>
                                                <div
                                                    className="badge bg-danger text-wrap"
                                                    title={
                                                        `Múltiples casos (${generalInfo.fichas} imputaciones)`
                                                    }
                                                >
                                                    <i className="fa fa-exclamation-triangle"></i>
                                                    <span className="ms-2">
                                                        Solicitar certificado de no antecedentes judiciales ({generalInfo.fichas} imputaciones)
                                                    </span>
                                                </div>
                                                <br />
                                            </>
                                            )}
                                            {(generalInfo.fichas ?? 0) === 1 && (<>
                                                <div
                                                    className="badge bg-warning text-dark text-wrap"
                                                    title={
                                                        "Solicitar certificado de no antecedentes judiciales"
                                                    }
                                                >
                                                    <i className="fa fa-exclamation-triangle"></i>
                                                    <span className="ms-2">
                                                        Solicitar certificado de no antecedentes judiciales
                                                    </span>
                                                </div>
                                                <br />
                                            </>
                                            )}
                                            {generalInfo.desaparecido && (
                                                <>
                                                    <div
                                                        className="badge bg-warning  text-wrap"
                                                        title={
                                                            "Desaparecid@"
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-triangle"></i>
                                                        <span className="ms-2">
                                                            Desaparecid@
                                                        </span>
                                                    </div>
                                                    <br />
                                                </>
                                            )}

                                            {generalInfo.deportado && generalInfo.deportado === true && (<><br />
                                                <span
                                                    className="badge "
                                                    style={{ backgroundColor: "purple" }}
                                                    title={
                                                        "Deportado"
                                                    }
                                                >
                                                    <i className="fa fa-exclamation-triangle me-2"></i>
                                                    Solicitar Certificado de no Deportación
                                                </span>
                                                <br />
                                            </>
                                            )}
                                            {hasLaborales ? (
                                                <div className="badge bg-warning text-dark text-wrap" title="Casos laborales detectados">
                                                    <i className="fa fa-exclamation-triangle"></i>
                                                    <span className="ms-2">Casos laborales detectados</span>
                                                </div>
                                            ) : (
                                                <div className="badge bg-success text-wrap" title="No casos laborales">
                                                    <i className="fa fa-check"></i>
                                                    <span className="ms-2">No casos laborales</span>
                                                </div>
                                            )}
                                            {(generalInfo as any).fichasBlancas > 0 && (
                                                <>
                                                    <br />
                                                    <div
                                                        className="badge bg-secondary text-wrap"
                                                        title={"Tiene anotaciones de interés (Ficha Blanca)"}
                                                    >
                                                        <i className="fa fa-info-circle"></i>
                                                        <span className="ms-2">Otros antecedentes (Ficha Blanca)</span>
                                                    </div>
                                                </>
                                            )}
                                            {user && user.RoleId === "admin" && (<><br />
                                                <button
                                                    className="btn me-2 btn-warning mx-2"
                                                    onClick={() => {
                                                        setShowAdmin(!showAdmin)
                                                        // props.history.push(Routes.Admin.clean)
                                                    }}
                                                >
                                                    <i className="fas fa-thunderstorm" />
                                                </button>
                                            </>
                                            )}

                                        </Col>
                                    </Row>


                                </Card.Body>
                                <Card.Footer className="text-center">
                                    <a href={`https://www.google.com/search?q=%22${generalInfo.nombres ?? ""} ${generalInfo.apellido1 ?? ""
                                        } ${generalInfo.apellido2 ?? ""}%22`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm me-2 mb-2">
                                        <i className="fa fa-google mx-2"></i>
                                        Buscar en Google
                                    </a>
                                    <a href={`https://www.google.com/search?q=${generalInfo.nombres?.split(" ")[0] ?? ""} ${generalInfo.apellido1 ?? ""} courts usao`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm me-2 mb-2">
                                        <i className="fa fa-google mx-2"></i>
                                        Buscar en Google <i className="fa fa-plus"></i>
                                    </a>
                                    <a href={`https://www.google.com/search?q=${generalInfo.nombres ?? ""} ${generalInfo.apellido1 ?? ""
                                        } ${generalInfo.apellido2 ?? ""} site:pgr.gob.do`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm me-2 mb-2">
                                        <i className="fa fa-earth-americas me-2"></i>
                                        Justicia
                                    </a>
                                    <a href={`https://www.google.com/search?q=${generalInfo.nombres?.split(" ")[0] ?? ""} ${generalInfo.apellido1 ?? ""} site:instagram.com`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm me-2 mb-2">
                                        <i className="fa fa-instagram mx-2"></i>
                                        Buscar en Instagram
                                    </a>
                                    <a href={`https://www.google.com/search?q=${generalInfo.nombres?.split(" ")[0] ?? ""} ${generalInfo.apellido1 ?? ""} ${generalInfo.apellido2 ?? ""} site:policianacional.gob.do`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm me-2 mb-2">
                                        <i className="fa fa-globe mx-2"></i>
                                        Buscar en Policia
                                    </a>
                                </Card.Footer>


                            </Card>
                        }
                        {/* COMPANIA */}

                        {generalInfo && isRnc &&
                            <Card className="my-4">
                                <Card.Body className="p-4 ">
                                    <Row>

                                        <Col>
                                            <b className="me-2">{t("Nombre")}:</b>
                                            {`${generalInfo.nombre ?? ""} `}
                                            <br />
                                            <b className="me-2">RNC</b>
                                            {generalInfo.rnc}

                                        </Col>

                                    </Row>


                                </Card.Body>
                                <Card.Footer className="text-center">

                                    <a href={`https://www.google.com/search?q=%22${generalInfo.nombre ?? ""}%22`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm mx-2">
                                        <i className="fa fa-google me-2"></i>
                                        Buscar en Google
                                    </a>
                                    <a href={`https://www.google.com/search?q=${generalInfo.nombre?.split(" ")[0] ?? ""} site:instagram.com`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm">
                                        <i className="fa fa-instagram mx-2"></i>
                                        Buscar en Instagram
                                    </a>
                                </Card.Footer>


                            </Card>
                        }
                        {isRnc && <RecordDGIIInfo rnc={normalizedId} />}
                        {isRnc && <RecordProviderContracts rnc={normalizedId} />}
                        {/* <RecordEmploymentInfo id={id} /> */}
                        {isCedula && (
                            <>
                                <RecordRelatives id={normalizedId} />
                                <RecordBiometrical id={normalizedId} />
                                <RecordJudicialRecords id={normalizedId} />
                                <RecordSentencias id={normalizedId} name={generalInfo?.nombre} />
                                <RecordAudiencias id={normalizedId} name={generalInfo?.nombre} onLaboralesDetected={setHasLaborales} />
                                <div className="col-6">
                                    <RecordVictimarios id={normalizedId} />
                                </div>
                            </>
                        )}

                        {/* <RecordComplices id={id} /> */}
                        {canLookupRecord && <RecordEstructura id={normalizedId} generalInfo={generalInfo} />}

                        {isCedula && (
                            <>
                                <RecordSalarios id={normalizedId} />
                                <RecordTelefonos id={normalizedId} />
                            </>
                        )}

                    </Col>
                </Row>
            </Container>
        </>

    )
}
export default RecordContainer;
